export const ENDPOINTS = {
  // auth
  LOGIN: '/users/login',
  SIGNUP: '/users/signup',
  RESET: '/users/reset',
  FORGOT: '/users/forgot',
  CHANGEPASS: '/users/changepass',

  // users
  COUNTRIES: '/users/signup/countries',
  PROFILE: '/users/profile',
  USERS_LIST: '/users',
  USERS_UPDATE: '/users/{email}',
  SIGNUPS: '/users/signup/list',
  SIGNUP_BY_EMAIL: '/users/signup/{userEmail}',
  SIGNUP_APPROVE: '/users/signup/approve',

  // cases
  CASE: '/cases/{caseId}',
  CASES: '/cases',
  CASES_IMAGE: '/cases/{caseId}/images/{imgPath}',
  CASE_FILE: '/cases/{caseId}/{filePath}',
  GENERATE_REPORT: '/cases/{caseId}/{dl_file_name}',
  CASE_CLAIM: '/cases/{caseId}/claim',
  // urgent cases
  URGENT_CASES_DASHBOARD: '/grades/urgent-cases-dashboard',
  CASE_COMMENTS: '/cases/{caseId}/comments',
  CASE_COMMENT: '/cases/{caseId}/comments/{commentId}',
  CLINIC_CASE_ADMINS: '/clinics/{clinicId}/case-admins',

  // image layers
  CASE_IMAGES_LAYER_URL: '/case-images/{caseId}/layers',
  CASE_IMAGES_DATA: '/case-images/{caseId}/data',
  CASE_IMAGES_INSIGHTS_STATUS: '/case-images/{caseId}/insights-status',

  // grades
  GRADES: '/grades',
  GRADE_TELEHEALTH_REPORT: '/grades/{grade_id}/telehealth-report',
  GRADE_TELEHEALTH_REPORT_DATA: '/grades/{grade_id}/telehealth-report-data',
  GRADE_ACKNOWLEDGE: '/grades/{grade_id}/set-acknowledge',
  INSIGHTS_DR_GRADES: '/insights/dr-grade',
  // licenses
  LICENSES: '/licenses',
  // LICENSE_REQUEST: '/licenses/request-license',
  LICENSE_REQUEST: '/users/{doctor_email}/license',
  LICENSE_FILE: '/licenses/{doctor_email}/{file}',

  // cameras
  CAMERAS: '/cameras',
  CAMERAS_BY_CLINIC: '/clinics/cameras',

  // counting
  COUNT_USERS: '/users/count',
  COUNT_CASES: '/cases/count',
  COUNT_CASES_IMAGES: '/cases/images/count',
  COUNT_PATIENTS: '/cases/patients/count',

  // stats for dashboard
  STATS: '/cases/stats',
  DASHBOARD_CASES: '/dashboard/cases',

  // billing
  CURRENT_BILLING: '/billing/plans/current',

  // legal
  LEGAL_DOCS: '/legal/documents',
  LEGAL_DOC_FILE: '/legal/documents/{filePath}',

  // clinics
  CLINIC: '/clinics/{clinicId}',
  CLINICS: '/clinics',
  ELIMINATE_CLINICS: '/clinics/{clinicId}/set-inactive',

  // sites
  SITES: '/clinics/sites',
  SITE_BY_ID: '/clinics/sites/{siteId}',
  ELIMINATE_SITE: '/clinics/{clinicId}/sites/{siteId}/set-inactive',

  // npi
  NPI_PROVIDERS: '/npi',
  NPI_PREFERRED: '/npi/preferred',

  // orders
  ORDER_INDICATIONS: '/order/indication',

  // ICD Codes
  ICD10_CODE_SUGGESTION: '/icd-codes/10/suggestions',

  // Two Factor Authentication
  TWO_FACTOR_GENERATE: '/2fa/generate',
  TWO_FACTOR_ENABLE: '/2fa/enable',
  TWO_FACTOR_DISABLE: '/2fa/disable',
  TWO_FACTOR_VERIFY: '/2fa/verify',

  // AI Search
  AI_SEARCH: '/ai-search',
  AI_SEARCH_MESSAGES: '/ai-search/{conversationId}/messages',
  AI_SEARCH_DOCS: '/ai-search/files',
  AI_SEARCH_DOC_FILE: '/ai-search/files/{fileId}',
  AI_SEARCH_DOC_PREVIEW_URL: '/ai-search/files/preview-url',

  // API Keys
  API_KEYS_LIST: '/users/{email}/keys',
  API_KEYS_CREATE: '/users/{email}/keys',
  API_KEYS_UPDATE_STATUS: '/keys/{keyHash}/status',
  API_KEYS_DELETE: '/keys/{keyHash}',
} as const;
